export const checkMessageOnBlockers = ({
  hasSignUpBlock,
  hasEmailConfirmationBlock,
  hasSubscriptionBlock,
  currentUser,
  game,
  customDialogsBatchesNumber,
  marketingData,
  totalBathesNumber,
  sending,
  setIsSignUpModalOpen,
  setIsEmailConfirmationModalOpen,
  setSubscriptionModalState,
  eventType = undefined,
}) => {

  if (hasSignUpBlock) {
    setIsSignUpModalOpen(true);
    return true;
  } else if (hasEmailConfirmationBlock) {
    setIsEmailConfirmationModalOpen(true);
    return true;
  } else if (hasSubscriptionBlock) {
    setSubscriptionModalState({
      isOpen: true,
      renderedForReason: eventType,
    });
    return true;
  } else if (
    !currentUser?.hasSubscription &&
    !game?.isPublic &&
    Number(customDialogsBatchesNumber) >= Number(marketingData?.custom_dialog_free_messages || 0)
  ) {
    setSubscriptionModalState({
      isOpen: true,
      renderedForReason: 'custom_dialog_free_messages_limit',
      showScenarioButton:
        Number(totalBathesNumber) < Number(marketingData?.chat_subscription_batches_number),
    });
    return true;
  } else if (sending) {
    return true;
  }
  return false;
};

export const scrollToBottom = () => {
  const element = document.getElementById('batches_wrapper');
  if (element) {
    element.scrollTo({ top: element.scrollHeight, behavior: 'smooth' });
  }
};
